import { GlobalRouter } from "@routes/index";

import "@styles/index.scss";
import "antd/dist/antd.less";
// import 'country-flag-icons/react/3x2';
import { useAuth } from "@hooks/useAuth";

function App() {
  const { user } = useAuth();

  return <GlobalRouter />;

}

export default App;
